export enum ProductCheckoutStatus {
    AsStandardUser,
    AsPendingLiableUser,
    AsLiableUser,
    AsSponsorUser
}
